import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing a filter view for landing reports.
 * @extends JetView
 */
export default class FilterLandingReportView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id', // Input for ID
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'Partner', // Dropdown for Partner selection
                            label: _('Partner'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.PartnerSelected, // Default selected value
                            options: profile.Partners, // Options from profile
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate', // Dropdown for activation status
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Second left section of the filter form
        const left2 = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified', // Dropdown for verification status
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: 'Todos' },
                                { id: 'A', value: 'Activado' },
                                { id: 'I', value: 'Inactivado' },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'FilterCountry', // Dropdown for country filter
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: 'Todos' },
                                { id: 'A', value: 'Activado' },
                                { id: 'I', value: 'Inactivado' },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'FeaturedOrder', // Input for featured order
                            type: 'number',
                            label: "<span class='icon-reorder'></span>" + _('Orden Destacado'),
                            labelPosition: 'top',
                            placeholder: _('Orden Destacado'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Maximum', // Input for maximum value
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Minimum', // Input for minimum value
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'ProcessingTime', // Input for processing time
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _(
                                'Tiempo Procesamiento is required', // Validation message
                            ),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeDevice', // Radio buttons for device type
                            label: _('Dispositivo'),
                            labelPosition: 'top',
                            value: 3, // Default selected value
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>",
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>",
                                },
                                { id: 3, value: 'Ambos' },
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section containing the first left section
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section containing the second left section
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('partnerProducts:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for basic filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for basic filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Include upper section
                                    buttons, // Include buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
